// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'vuetify/dist/vuetify.min.css';
import 'babel-polyfill';

import Vue from 'vue';
import VueResource from 'vue-resource';
import Vuetify from 'vuetify';
import Vuefire from 'vuefire';

import App from './App';
import router from './router';
import store from './store';
import firebase from './services/firebase';

Vue.use(require('vue-moment'));

Vue.use(VueResource);
Vue.use(Vuefire);
Vue.use(Vuetify, {
  theme: {
    primary: '#0D47A1',
    secondary: '#1976D2',
    accent: '#2196F3',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50',
  },
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  firebase: {
    lionCounter: {
      source: firebase.database.ref('lionCounter'),
      asObject: true,
    },
    matches: firebase.database.ref('matches').orderByChild('date'),
  },
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js